"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityMapping = void 0;
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var debounce_1 = __importDefault(require("lodash/debounce"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FeatureFlag_1 = __importStar(require("@CommonFrontendBackend/FeatureFlag"));
var inversify_react_1 = require("inversify-react");
var OptionCheckbox_1 = require("../OptionCheckbox/OptionCheckbox");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./IdentityMapping.css"));
var IdentityMapping = (function (_super) {
    __extends(IdentityMapping, _super);
    function IdentityMapping() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errorMessage = "";
        _this.allowedDomainsLocalCopy = "";
        _this.domainsInputRef = (0, react_1.createRef)();
        _this.previousLimitDomainsEnabled = _this.dataStore.isLimitDomainsEnabled;
        _this.toggleEmailVerification = function () {
            _this.dataStore.setEmailVerification(!_this.dataStore.isEmailVerificationEnabled);
        };
        _this.toggleLimitDomains = function () {
            _this.dataStore.setLimitDomainsEnabled(!_this.dataStore.isLimitDomainsEnabled);
        };
        _this.toggleIdentifyByName = function () {
            _this.dataStore.setIdentifyByNameEnabled(!_this.dataStore.isIdentifyByNameEnabled);
        };
        _this.toggleIdentifyByEmail = function () {
            _this.dataStore.setIdentifyByEmailEnabled(!_this.dataStore.isIdentifyByEmailEnabled);
        };
        _this.debouncedUpdateAllowedDomains = (0, debounce_1.default)(function () {
            if (_this.allowedDomainsLocalCopy.includes("@")) {
                return _this.setErrorMessage("Domains can't include an @ sign");
            }
            var validDomain = _this.dataStore.setAllowedDomains(_this.allowedDomainsLocalCopy);
            if (!validDomain) {
                _this.setErrorMessage("Incorrect domain value");
            }
        }, 1000);
        return _this;
    }
    IdentityMapping.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, Promise, function () {
            var msg;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.originalSettingsSnapshot = this.dataStore.rawIdentityMapping;
                        this.allowedDomainsLocalCopy = this.dataStore.allowedDomains;
                        return [4, this.props.getUpsellMessage(FeatureFlag_1.default.IdentityMapping)];
                    case 1:
                        msg = _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.identityMappingUpsell = msg;
                        });
                        return [2];
                }
            });
        });
    };
    IdentityMapping.prototype.componentWillUnmount = function () {
        var _this = this;
        var changeActions = [];
        var prevIdentityMapping = this.originalSettingsSnapshot;
        var currIdentityMapping = this.dataStore.rawIdentityMapping;
        if (prevIdentityMapping.emailVerificationEnabled != currIdentityMapping.emailVerificationEnabled) {
            changeActions.push(currIdentityMapping.emailVerificationEnabled ? "email_auth_enabled" : "email_auth_disabled");
        }
        if (prevIdentityMapping.limitDomains.enabled != currIdentityMapping.limitDomains.enabled) {
            changeActions.push(currIdentityMapping.limitDomains.enabled ? "domain_restriction_enabled" : "domain_restriction_disabled");
        }
        changeActions.map(function (action) { return _this.props.sendSettingChangedTelemetry(action); });
    };
    IdentityMapping.prototype.componentDidUpdate = function () {
        var _a;
        if (this.dataStore.isLimitDomainsEnabled) {
            if (!this.previousLimitDomainsEnabled) {
                (_a = this.domainsInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
            if (this.allowedDomainsLocalCopy.length === 0) {
                this.setErrorMessage("Please provide a domain");
            }
        }
        this.previousLimitDomainsEnabled = this.dataStore.isLimitDomainsEnabled;
    };
    Object.defineProperty(IdentityMapping.prototype, "limitedDomainsToggleDisable", {
        get: function () {
            return !this.dataStore.isEmailVerificationEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IdentityMapping.prototype, "limitedDomainsToggleDisabledReason", {
        get: function () {
            if (this.props.canUseIdentityMapping) {
                return "Please enable email verification to use domain security.";
            }
            return this.identityMappingUpsell;
        },
        enumerable: false,
        configurable: true
    });
    IdentityMapping.prototype.setErrorMessage = function (errorMessage) {
        this.errorMessage = errorMessage;
    };
    IdentityMapping.prototype.clearErrorMessage = function () {
        this.errorMessage = "";
    };
    IdentityMapping.prototype.updateAllowedDomains = function (domains) {
        this.clearErrorMessage();
        this.allowedDomainsLocalCopy = domains;
        if (this.allowedDomainsLocalCopy.includes("@")) {
            return this.setErrorMessage("Domains can't include an @ sign");
        }
        this.debouncedUpdateAllowedDomains();
    };
    Object.defineProperty(IdentityMapping.prototype, "dataStore", {
        get: function () {
            return this.props.identityMappingStore;
        },
        enumerable: false,
        configurable: true
    });
    IdentityMapping.prototype.render = function () {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l" },
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s", align: "center" }, "Show a screen that requires clients to enter their details before viewing the page."),
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", direction: "horizontal" },
                react_1.default.createElement(icons_1.User, { color: "default" }),
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "5", strong: true }, "Identification")),
            react_1.default.createElement("div", null,
                react_1.default.createElement(OptionCheckbox_1.OptionCheckbox, { item: {
                        id: "identify-by-name-checkbox",
                        value: "identify-by-name-checkbox",
                        label: "Name",
                    }, isSelected: this.dataStore.isIdentifyByNameEnabled, onChange: this.toggleIdentifyByName, isDisabled: !this.props.canUseIdentityMapping, disabledReason: this.identityMappingUpsell }),
                react_1.default.createElement(OptionCheckbox_1.OptionCheckbox, { item: {
                        id: "identify-by-email-checkbox",
                        value: "identify-by-email-checkbox",
                        label: "Email",
                    }, isSelected: this.dataStore.isIdentifyByEmailEnabled, onChange: this.toggleIdentifyByEmail, isDisabled: !this.props.canUseIdentityMapping, disabledReason: this.identityMappingUpsell })),
            react_1.default.createElement("hr", { className: styles.divider }),
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", direction: "horizontal" },
                react_1.default.createElement(icons_1.Security, { color: "default" }),
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "5", strong: true }, "Security")),
            react_1.default.createElement("div", null,
                react_1.default.createElement(OptionCheckbox_1.OptionCheckbox, { item: {
                        id: "authentication-checkbox",
                        value: "authentication-checkbox",
                        label: "Email verification",
                    }, isSelected: this.dataStore.isEmailVerificationEnabled, onChange: this.toggleEmailVerification, isDisabled: !this.props.canUseIdentityMapping, explainer: {
                        heading: "Secure email verification",
                        content: "Sends a verification email to verify that the viewer owns the email used to access the page.",
                    }, disabledReason: this.identityMappingUpsell }),
                react_1.default.createElement(OptionCheckbox_1.OptionCheckbox, { item: {
                        id: "domain-checkbox",
                        value: "domain-checkbox",
                        label: "Domain security",
                    }, isSelected: this.dataStore.isLimitDomainsEnabled, onChange: this.toggleLimitDomains, isDisabled: this.limitedDomainsToggleDisable, explainer: {
                        heading: "Domain security",
                        content: "Only allow emails from particular domains.",
                    }, disabledReason: this.limitedDomainsToggleDisabledReason }),
                this.dataStore.isLimitDomainsEnabled && (react_1.default.createElement(kaleidoscope_1.TextInput, { label: "Allowed domains", id: "limit-domains-input", labelHidden: true, error: this.errorMessage, disabled: !this.dataStore.isLimitDomainsEnabled, value: this.allowedDomainsLocalCopy, placeholder: "e.g. mydomain.com, another.com", onChange: this.updateAllowedDomains, ref: this.domainsInputRef })))));
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], IdentityMapping.prototype, "errorMessage", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], IdentityMapping.prototype, "identityMappingUpsell", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], IdentityMapping.prototype, "allowedDomainsLocalCopy", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("usingFeature"),
        __metadata("design:type", typeof (_a = typeof FeatureFlag_1.usingFeatureType !== "undefined" && FeatureFlag_1.usingFeatureType) === "function" ? _a : Object)
    ], IdentityMapping.prototype, "usingFeature", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], IdentityMapping.prototype, "limitedDomainsToggleDisable", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], IdentityMapping.prototype, "limitedDomainsToggleDisabledReason", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], IdentityMapping.prototype, "setErrorMessage", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], IdentityMapping.prototype, "clearErrorMessage", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], IdentityMapping.prototype, "updateAllowedDomains", null);
    IdentityMapping = __decorate([
        mobx_react_1.observer
    ], IdentityMapping);
    return IdentityMapping;
}(react_1.default.Component));
exports.IdentityMapping = IdentityMapping;
exports.default = IdentityMapping;
